export function createWhereConditionForBranchId(branchId?: number | number[], companyId?: number) {
  if (Array.isArray(branchId) && branchId.length) {
    return { id: branchId, companyId };
  }
  if (typeof branchId === "number") {
    return { id: branchId, companyId };
  }

  return undefined;
}
